export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="border-t border-[var(--pa-border)] mt-12 sm:mt-16 py-8 px-6 md:px-12 text-center text-xs text-[var(--pa-text-dim)] shrink-0"
    >
      <div className="max-w-5xl mx-auto space-y-2">
        <div className="kicker text-[var(--pa-gold)]" data-testid="footer-patent">
          Patent Pending USPTO #64/062,147 · CamelionAI LLC — Boca Raton, FL
        </div>
        <div data-testid="footer-founder">
          <span className="text-[var(--pa-text-muted)] font-serif">
            Built by Dr. Ronik Seecharan, DMD
          </span>{" "}
          — Prosthodontist &amp; Founder, CamelionAI LLC
        </div>
        <div className="opacity-60">
          © {new Date().getFullYear()} CamelionAI LLC. ProsthoAI is a clinical decision support
          platform for licensed dental professionals. Not a substitute for professional judgment.
        </div>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 pt-1 text-[11px]">
          <a
            href="/legal/disclaimer"
            data-testid="footer-disclaimer-link"
            className="text-[var(--pa-text-muted)] hover:text-[var(--pa-gold)] underline-offset-2 hover:underline"
          >
            Clinical Decision Support Disclaimer
          </a>
          <a
            href="/baa"
            className="text-[var(--pa-text-muted)] hover:text-[var(--pa-gold)] underline-offset-2 hover:underline"
          >
            BAA
          </a>
          <a
            href="/terms"
            className="text-[var(--pa-text-muted)] hover:text-[var(--pa-gold)] underline-offset-2 hover:underline"
          >
            Terms
          </a>
        </div>
        <div className="opacity-50 pt-1">
          A{" "}
          <a
            href="https://camelionai.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-camelionai"
            className="text-[var(--pa-gold)] hover:underline underline-offset-2"
          >
            CamelionAI LLC
          </a>{" "}
          product
        </div>
      </div>
    </footer>
  );
}
